import {useState} from 'react';

export function DisplayMobileTabs({tabNames, sections}) {
  const [open, setOpen] = useState();

  return (
    <div className='mt-3 font-oswald-lightest'>
      <div className='border-t-2 border-[#26292B]' />

      {tabNames?.map((item, index) => (
        <div key={item}>
          <div
            id={item}
            style={{
              background: index === open ? '#26292B' : 'white',
              color: index === open ? 'white' : '#26292B'
            }}
            className="px-5 duration-300 py-2 border-b-2 border-[#26292B]">
            <button
              onClick={() => setOpen(index === open ? null : index)}
              className='flex w-full items-center justify-between'>
              <div className="uppercase" style={{fontSize: '18px', fontWeight: '800'}}>{item}</div>
              <svg
                xmlns='http://www.w3.org/2000/svg'
                className='h-[16px] w-[16px] mr-1 duration-300'
                fill='none'
                viewBox='0 0 24 24'
                stroke='currentColor'
                strokeWidth='2'
                style={{transform: open === index ? 'rotate(90deg)' : 'rotate(0deg)'}}>
                <path strokeLinecap='round' strokeLinejoin='round' d='M9 5l7 7-7 7' />
              </svg>
            </button>
            <div className={`divider-gradient ${index === open ? '' : 'hidden'}`} />
          </div>
          {open === index && (
            <div
              className='duration-300 overflow-hidden'
              style={{
                height: 'auto',
                background: '#26292B'
              }}>
              <div id={`desc-${item}`} className="mb-3 text-white mx-5 desc">
                {/* Render the section directly without additional props */}
                {sections[index]}
              </div>
            </div>
          )}
        </div>
      ))}
    </div>
  );
}
